import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import AgregarSocioPage from '../modules/socios/AgregarSocioPage'
import ListadoCuentas from '../modules/cuentas/ListadoCuentas'
import DetalleCuenta from '../modules/cuentas/DetalleCuenta'
import SocioDetallePage from '../modules/socios/SocioDetallePage'
import MovimientosPage from '../modules/movimientos/MovimientosPage'
import ServiciosPage from '../modules/servicios/ServiciosPage'
import CreateServicioPage from '../modules/servicios/CreateServicioPage'
import EditServicioPage from '../modules/servicios/EditServicioPage'
import UsuariosPage from '../modules/usuarios/UsuariosPage'
import CreateUsuarioPage from '../modules/usuarios/CreateUsuarioPage'
// Import dinámico para Ingresar Comisiones
// import EmitirCobranzaPage from '../modules/cobranza/EmitirCobranzaPage'

const PrivateRoutes = () => {
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const SociosPage = lazy(() => import('../modules/socios/SociosPage'))
  const EmitirCobranzaPage = lazy(() => import('../modules/cobranza/EmitirCobranzaPage'))
  const IngresarComisionesPage = lazy(() => import('../modules/cobranza/IngresarComisionesPage'))
  const AdministracionFEPage = lazy(() => import('../modules/cobranza/AdministracionFEPage'))
  const IngresarPagosPage = lazy(() => import('../modules/pagos/IngresarPagosPage'))
  const BancosPage = lazy(() => import('../modules/pagos/BancosPage'))
  const ReportePage = lazy(() => import('../modules/reportes/ReportePage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route
          path='socios/listado'
          element={
            <SuspensedView>
              <SociosPage />
            </SuspensedView>
          }
        />
        <Route
          path='/socios/ingresar'
          element={
            <SuspensedView>
              <AgregarSocioPage />
            </SuspensedView>
          }
        />
        <Route
          path='/socios/:id'
          element={
            <SuspensedView>
              <SocioDetallePage />
            </SuspensedView>
          }
        />

        <Route
          path='/cuentas/listado'
          element={
            <SuspensedView>
              <ListadoCuentas />
            </SuspensedView>
          }
        />

        <Route
          path='/cuentas/:numero'
          element={
            <SuspensedView>
              <DetalleCuenta />
            </SuspensedView>
          }
        />

        <Route
          path='/movimientos/listado'
          element={
            <SuspensedView>
              <MovimientosPage />
            </SuspensedView>
          }
        />

        <Route
          path='/servicios/listado'
          element={
            <SuspensedView>
              <ServiciosPage />
            </SuspensedView>
          }
        />

        <Route
          path='/servicios/ingresar'
          element={
            <SuspensedView>
              <CreateServicioPage />
            </SuspensedView>
          }
        />

        <Route
          path='/servicios/edit/:id'
          element={
            <SuspensedView>
              <EditServicioPage />
            </SuspensedView>
          }
        />

        <Route
          path='/usuarios'
          element={
            <SuspensedView>
              <UsuariosPage />
            </SuspensedView>
          }
        />

        <Route
          path='/usuarios/crear'
          element={
            <SuspensedView>
              <CreateUsuarioPage />
            </SuspensedView>
          }
        />

        <Route
          path='/usuarios/editar/:id'
          element={
            <SuspensedView>
              <CreateUsuarioPage />
            </SuspensedView>
          }
        />

        <Route
          path='/cobranza/emitir'
          element={
            <SuspensedView>
              <EmitirCobranzaPage />
            </SuspensedView>
          }
        />

        <Route
          path='/cobranza/comisiones'
          element={
            <SuspensedView>
              <IngresarComisionesPage />
            </SuspensedView>
          }
        />

        <Route
          path='/cobranza/facturacion-electronica'
          element={
            <SuspensedView>
              <AdministracionFEPage />
            </SuspensedView>
          }
        />

        <Route
          path='/pagos/ingresar'
          element={
            <SuspensedView>
              <IngresarPagosPage />
            </SuspensedView>
          }
        />

        <Route
          path='/pagos/bancos'
          element={
            <SuspensedView>
              <BancosPage />
            </SuspensedView>
          }
        />

        <Route
          path='/reportes/:slug'
          element={
            <SuspensedView>
              <ReportePage />
            </SuspensedView>
          }
        />

        <Route
          path='/test'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/dashboard' />} />
        {/* <Route path='*' element={<Navigate to='/error/404' />} /> */}



        {/* <Route path='builder' element={<BuilderPageWrapper />} /> */}
        {/* <Route path='menu-test' element={<MenuTestPage />} /> */}
        {/* Lazy Modules */}
        {/* <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        /> */}
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
